import { CSSObject } from 'styled-components';
import { Get } from 'type-fest';

import componentsSettings from './components/settings';

import { palette } from './palette';
import { transparentize } from 'polished';

export const theme = {
  colors: palette,
  space: [0, 2, 4, 8, 12, 16, 24, 32, 40, 64, 80],
  radii: [2, 4, 6, 8, 16],
  fontSizes: [12, 14, 16, 20, 30, 36],
  sizes: [8, 12, 16, 24, 28, 36, 64],
  fontWeights: [400, 500, 600, 700],
  borderWidths: [0, 2],
  lineHeights: ['16px', '20px', '24px', '32px', '40px', '64px'],
  breakpoints: ['768px', '1000px'],
  boxShadows: {
    input: `0px 2px 4px ${transparentize(0.85, palette.black.dark)}`,
  },
  fonts: {
    primary: "'Montserrat', sans-serif",
    secondary: '"Open Sans", sans-serif',
  },
  components: componentsSettings,
};

export type ComponentsTheme = typeof theme;

export type FontWeight = (typeof theme.fontWeights)[number] | 'inherit';

export type Theme = ComponentsTheme & {
  components: Record<
    keyof ComponentsTheme['components'],
    {
      cssOverrides?: CSSObject;
    }
  >;
};

export type Components = Get<ComponentsTheme, 'components'>;

export type ComponentsVariants =
  | keyof Get<Components, 'Button.componentVariants'>
  | keyof Get<Components, 'BodyText.componentVariants'>
  | keyof Get<Components, 'Heading.componentVariants'>
  | keyof Get<Components, 'Input.componentVariants'>
  | keyof Get<Components, 'InputMessage.componentVariants'>
  | keyof Get<Components, 'Tag.componentVariants'>
  | keyof Get<Components, 'Card.componentVariants'>
  | keyof Get<Components, 'Tooltip.componentVariants'>
  | keyof Get<Components, 'Toggle.componentVariants'>
  | keyof Get<Components, 'ProgressBar.componentVariants'>
  | keyof Get<Components, 'BankAccount.componentVariants'>
  | keyof Get<Components, 'CreditCard.componentVariants'>
  | keyof Get<Components, 'RadioSelect.componentVariants'>
  | keyof Get<Components, 'FormField.componentVariants'>
  | keyof Get<Components, 'Checkbox.componentVariants'>
  | keyof Get<Components, 'TagInput.componentVariants'>
  | keyof Get<Components, 'Select.componentVariants'>
  | keyof Get<Components, 'StepHorizontal.componentVariants'>
  | keyof Get<Components, 'StepVertical.componentVariants'>
  | keyof Get<Components, 'Table.componentVariants'>
  | keyof Get<Components, 'ToastMessage.componentVariants'>
  | keyof Get<Components, 'Tabs.componentVariants'>
  | keyof Get<Components, 'RadioButton.componentVariants'>
  | keyof Get<Components, 'Options.componentVariants'>
  | keyof Get<Components, 'TextArea.componentVariants'>
  | keyof Get<Components, 'CreditCardNumber.componentVariants'>
  | keyof Get<Components, 'CreditCardHolderDetails.componentVariants'>
  | keyof Get<Components, 'CreditCardAddress.componentVariants'>
  | keyof Get<Components, 'Accordion.componentVariants'>
  | keyof Get<Components, 'PageHeaderTitle.componentVariants'>
  | keyof Get<Components, 'PageHeaderSubtitle.componentVariants'>;
